import { render } from "./UploadDocumentos.vue?vue&type=template&id=45fb44dc&scoped=true"
import script from "./UploadDocumentos.vue?vue&type=script&lang=js"
export * from "./UploadDocumentos.vue?vue&type=script&lang=js"

import "./UploadDocumentos.vue?vue&type=style&index=0&id=45fb44dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fb44dc"]])

export default __exports__